import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Camera as CameraIcon } from 'lucide-react';
import Cameras from './Cameras';

/**
 * SMS AI -- the platform-native AI surface. Two sub-tabs:
 *
 *   (Predictive Intelligence MOVED to the AI Facility Chatbot 2026-07-21.)
 *   1. [moved] churn risk scoring, predictive
 *      maintenance, demand forecasting. Phase 5 of the dashboard
 *      roadmap; UI stub tonight, scoring models ship later.
 *
 *   2. Camera Intelligence -- a MICROSERVICE each facility connects to
 *      (2026-08-29, provider-neutral). The product is a TENANT of the
 *      camera engine: Cameras.js renders the Morning Brief, the
 *      open-review list with OK / Not OK, the camera registry and the
 *      known-vehicle library through the server-side passthrough. No
 *      vision logic lives here.
 *
 * URL contract: /sms-ai (camera only; ?view= retained for old links).
 */

// Camera only. Predictive Intelligence moved to the AI Facility Chatbot
// (2026-07-21): churn risk / maintenance / demand forecasting are ANSWERS
// ABOUT THE FACILITY, which is what the chatbot surface is for — not a
// camera concern.
const TABS = [
  {
    key: 'camera',
    label: 'Camera Intelligence',
    icon: CameraIcon,
    desc: 'Morning Brief, flagged events with one-tap OK / Not OK, cameras',
  },
];


const SmsAi = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get('view');
  const tab = TABS.find((t) => t.key === rawTab) ? rawTab : 'camera';
  const setTab = (key) => {
    const params = new URLSearchParams(searchParams);
    if (key === 'camera') params.delete('view');
    else params.set('view', key);
    setSearchParams(params, { replace: true });
  };

  const active = TABS.find((t) => t.key === tab);

  return (
    <div>
      <div className="mb-5">
        <h1 className="text-xl font-semibold text-slate-900">AI Camera Agent</h1>
        <p className="text-[13px] text-slate-400 mt-0.5">
          {active?.desc || 'Agentic AI surfaces for self-storage operations'}
        </p>
      </div>

      <div className="border-b border-slate-200 mb-5 overflow-x-auto">
        <nav className="flex gap-1">
          {TABS.map((t) => {
            const Icon = t.icon;
            const isActive = tab === t.key;
            return (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`flex items-center gap-1.5 px-4 py-2.5 text-[13px] font-medium border-b-2 transition-colors whitespace-nowrap ${
                  isActive
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-slate-500 hover:text-slate-700'
                }`}
              >
                <Icon className="h-3.5 w-3.5" />
                {t.label}
              </button>
            );
          })}
        </nav>
      </div>

      {tab === 'camera' && <Cameras />}
    </div>
  );
};

export default SmsAi;
